// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"3d97748c","192":"8b36fba3","382":"94013dde","453":"261658b5","598":"c0276de1","614":"af4b13e9","803":"fbaa19b4","844":"87a3f9d4"}[chunkId] + ".chunk.js";
};